/**
 * Check aggregator — runs every local check (content + runtime) and
 * returns the results with elapsed time. The dashboard component
 * augments these categories with remote API health results.
 */

import type { Category } from '../types';
import {
  checkTomlPipeline,
  checkHotbarContracts,
  checkEquipmentContracts,
  checkLootContracts,
  checkCombatFeedbackContracts,
  checkMobRendering,
} from './content';
import {
  checkServiceRegistry,
  checkEventBusHealth,
  checkSharedConstants,
  checkDataIntegrity,
  checkSyncArchitecture,
  checkMultiplayerDiagnostics,
  checkServerContracts,
} from './runtime';
import { checkLobbyToolsContracts } from './lobbyTools';
import { checkAbilityContracts } from './abilities';

export function runAllChecks(): { categories: Category[]; elapsed: number } {
  const start = performance.now();
  const categories = [
    checkTomlPipeline(),
    checkHotbarContracts(),
    checkEquipmentContracts(),
    checkLootContracts(),
    checkCombatFeedbackContracts(),
    checkMobRendering(),
    checkServiceRegistry(),
    checkEventBusHealth(),
    checkSharedConstants(),
    checkDataIntegrity(),
    checkSyncArchitecture(),
    checkMultiplayerDiagnostics(),
    checkServerContracts(),
    checkLobbyToolsContracts(),
    // Ability contracts — folded in from the former standalone dashboard (returns
    // a system-health category + one per class, so spread into the flat list).
    ...checkAbilityContracts(),
  ];
  const elapsed = performance.now() - start;
  return { categories, elapsed };
}
